export enum TOURNAMENT_TYPE {
  BASIC = "BASIC",
  PRO = "PRO",
  ROOKIE = "ROOKIE",
  PRO_PERCENT = "PRO_PERCENT",
  ROOKIE_PERCENT = "ROOKIE_PERCENT",
  PRACTICE_HTML = "PRACTICE_HTML",
  PRACTICE_STREAM = "PRACTICE_STREAM",
}
